export default __webpack_public_path__ + "static/media/return-icon.4c915cb4.svg";